export const AppStyles = () => ({
    App: {
        alignItems: 'center',
        display: 'flex',
        height: '100vh !important',
        textAlign: 'center',
    },
    container: {
        container: 2,
    },
    main: {
        flexGrow: 1,
        minHeight: '100vh',
        padding: 1,
        textAlign: 'left',
        overflow: 'auto',
    },
});